//@flow
import React from 'react';
import {makeStyles} from '@material-ui/core';
import type {Theme} from '@material-ui/core';
import {Close} from '@material-ui/icons';
import {colors} from '../../assets/styles/colors';

type Props = {
  label: string,
  onDelete: () => void,
};

const useStyles = makeStyles((theme: Theme) => ({
  root: {
    display: 'inline-flex',
    alignItems: 'center',
    gap: '.125rem',
    background: colors.lightPurple,
    color: colors.purple,
    padding: '.25rem .45rem .25rem .65rem',
    borderRadius: '1rem',
  },
  label: {
    fontSize: '.85rem',
    fontWeight: 500,
  },
  button: {
    padding: 0,
    color: colors.purple,
    display: 'flex',
    alignItems: 'center',
    background: 'none',
    border: 'none',
    cursor: 'pointer',
  },
}));

export default function TagItem(props: Props) {
  const {label, onDelete} = props;

  const classes = useStyles();

  return (
    <div className={classes.root}>
      <span className={classes.label}>{label}</span>
      <button type="button" onClick={onDelete} className={classes.button}>
        <Close fontSize="small" />
      </button>
    </div>
  );
}
